module.exports = __webpack_public_path__ + "static/img/SM.876237ac.jpg";